export default __webpack_public_path__ + "static/media/ShareholderMeetingCircular.ca6a42a3.pdf";